<template>
  <BusinessCrud
    title="产品参数"
    :columns="columns"
    :search-fields="searchFields"
    :form-fields="formFields"
    :list-api="getProductParamList"
    :save-api="saveProductParam"
    :delete-api="deleteProductParam"
    :defaults="{ isVisible: 1, sortOrder: 0 }"
  />
</template>

<script>
import BusinessCrud from '@/components/BusinessCrud'
import { getProductParamList, saveProductParam, deleteProductParam } from '@/api'

export default {
  components: { BusinessCrud },
  data() {
    return {
      getProductParamList,
      saveProductParam,
      deleteProductParam,
      searchFields: [
        { key: 'productName', label: '产品名称' },
        { key: 'paramName', label: '参数名称' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '产品名称', dataIndex: 'productName' },
        { title: '参数名称', dataIndex: 'paramName' },
        { title: '参数值', dataIndex: 'paramValue' },
        { title: '单位', dataIndex: 'unit' },
        { title: '展示', dataIndex: 'isVisible', scopedSlots: { customRender: 'status' } },
        { title: '排序', dataIndex: 'sortOrder' }
      ],
      formFields: [
        { key: 'productId', label: '产品ID', type: 'number', min: 0 },
        { key: 'productName', label: '产品名称' },
        { key: 'paramName', label: '参数名称' },
        { key: 'paramValue', label: '参数值' },
        { key: 'unit', label: '单位' },
        { key: 'sortOrder', label: '排序', type: 'number', min: 0 },
        { key: 'isVisible', label: '前台展示', type: 'switch' }
      ]
    }
  }
}
</script>
